// extracted by mini-css-extract-plugin
export default {"wrapper":"EventCardCarousel-module__wrapper___2VXja"};